import React from 'react';
import { CtaButton } from './CtaButton';
import { CollectionMockup } from './CollectionMockup';
import { cta, hero } from '../data/content';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-91" data-mp="9ktdnmoh20x8">
      <div className="mx-auto max-w-3xl px-5 pb-12 pt-8 text-center sm:px-6 lg:pb-16 lg:pt-14" data-id="element-92" data-mp="9lv00naxu9u9">
        <p className="font-sans text-[0.68rem] font-semibold uppercase tracking-[0.24em] text-mustard sm:text-xs" data-id="element-93" data-mp="4mrsmw7hjrj4">
          {hero.eyebrow}
        </p>

        <h1 className="mx-auto mt-4 font-display text-[2.2rem] font-semibold leading-[1.04] tracking-tight text-ivory sm:text-6xl" data-id="element-94" data-mp="1274kvg6l3030">
          <span className="block" data-id="element-95" data-mp="sai535t46z7u">{hero.titleLine1}</span>
          <span className="block" data-id="element-96" data-mp="sd4bh249r8oh">
            {hero.titleLine2Start} <span className="text-mustard" data-id="element-97" data-mp="nbexbdlr2ew6">{hero.titleHighlight}</span>
          </span>
        </h1>

        <p className="mx-auto mt-4 max-w-xl font-sans text-[1.05rem] font-medium leading-relaxed text-ivory/85 sm:text-xl" data-id="element-98" data-mp="3d2bkbqsid1w2">
          {hero.subtitle}
        </p>

        <p className="mt-5 inline-flex rounded-full border border-mustard/50 px-4 py-1.5 font-sans text-[0.8rem] font-semibold text-mustard sm:text-sm" data-id="element-99" data-mp="3j8sfs1yzrlqd">
          {hero.productLine}
        </p>

        <div className="mx-auto mt-6 max-w-2xl" data-id="element-100" data-mp="39alaige2es47">
          <CollectionMockup variant="photo" data-id="element-101" data-mp="399te53cn8qcv" />
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-102" data-mp="3e8wjkowjcyld">
          <CtaButton data-id="element-103" data-mp="3e7l6tzl44gi4">{cta.primary}</CtaButton>
          <p className="mt-3 font-sans text-xs text-ivory/70 sm:text-sm" data-id="element-104" data-mp="30hhpnn13bczj">{hero.microcopy}</p>
        </div>
      </div>
    </header>;
}